//@flow

import {setGTMIntegrationApi, getGTMIntegrationApi} from './api';

import type {StoreGtmResponse} from '../../../entities';

export function setGTMIntegrationService(
  measurementId: string
): Promise<StoreGtmResponse> {
  return setGTMIntegrationApi({measurementId, enabled: true}).toPromise();
}

type UpdateGTMIntegrationService = {
  measurementId?: string,
  enabled?: boolean,
};

export function updateGTMIntegrationService({
  enabled,
  measurementId,
}: UpdateGTMIntegrationService): Promise<StoreGtmResponse> {
  return setGTMIntegrationApi({enabled, measurementId}).toPromise();
}

export function getGTMIntegrationService(): Promise<StoreGtmResponse> {
  return getGTMIntegrationApi().toPromise();
}

export function deleteGTMIntegrationService() {
  return setGTMIntegrationApi({
    measurementId: '',
  }).toPromise();
}
